export default __webpack_public_path__ + "static/media/media.09b2038b.svg";